<template>
  <div class="deal-intro" style="">
    <div class="media-block">
      <img
        class="contain-image"
        :src="deal.product.image.url"
        :alt="
          translateUcFirst('justopp.deals.productImageAlt', {
            name: deal.product.name,
          })
        " />
    </div>
    <div class="brand-block flex-row flex-middle gap-m">
      <div class="brand-image-container">
        <img
          class="contain-image"
          :src="deal.seller.image.url"
          :alt="
            translateUcFirst('justopp.deals.brandLogoAlt', {
              name: deal.seller.name,
            })
          " />
      </div>
      <div class="brand-name-container flex-column flex-start">
        <!--
        <span class="brand-label"
          >{{ translateUcFirst("justopp.deals.brandLabel") }}:</span
        >-->
        <span class="brand-name">{{ deal.seller.name }}</span>
      </div>
    </div>
    <div class="product-block">
      <div class="product-name">{{ deal.product.name }}</div>
      <div class="product-description">{{ deal.product.shortDescription }}</div>
    </div>
    <div class="info-separator"></div>
    <div class="details-block">
      <div class="detail">
        <div class="detail__label">
          {{ translateUcFirst("justopp.deals.quantity") }}:
        </div>
        <div class="detail__data">{{ deal.pricing.totalQuantity }}</div>
      </div>
      <div class="detail">
        <div class="detail__label">
          {{ translateUcFirst("justopp.deals.minimumQuantity") }}:
        </div>
        <div class="detail__data">{{ deal.pricing.minimumQuantity }}</div>
      </div>
      <div class="detail">
        <div class="detail__label">
          {{ translateUcFirst("justopp.deals.partialPurchase") }}:
        </div>
        <div class="detail__data">
          <icon
            :icon="deal.pricing.partialSellAllowed ? 'check' : 'x'"
            :theme="
              deal.pricing.partialSellAllowed ? 'success' : 'error'
            "></icon>
        </div>
      </div>
    </div>
    <div class="info-separator"></div>
    <div class="cta-block relative z-level-2">
      <div class="deal-actions flex-column flex-stretch gap-m">
        <form-button
          class="deal-action-button"
          inner-class=" deal-action-button flex width-expand"
          icon="clipboard-check"
          theme="alt">
          <template #text>
            <div class=" button-text flex width-expand">
              <span class="flex-between width-expand">
                <span>{{ translate("justopp.deals.bidFromCta") }} </span>
                <strong>{{
                  translateNumber(deal.pricing.currentBid, "currency", {
                    currency: deal.pricing.currency,
                  })
                }}</strong>
              </span>
            </div>
          </template>
        </form-button>
        <form-button
          class="deal-action-button"
          inner-class="flex width-expand"
          icon="check"
          theme="success">
          <template #text>
            <div class="button-text flex width-expand">
              <span class="flex-between width-expand">
                <span>{{ translate("justopp.deals.buyNowCta") }} </span>
                <strong>{{
                  translateNumber(deal.pricing.unitPrice, "currency", {
                    currency: deal.pricing.currency,
                  })
                }}</strong>
              </span>
            </div>
          </template>
        </form-button>
      </div>
    </div>
    <a href="https://google.com" class="deal-link absolute-cover z-level-1"></a>
  </div>
</template>

<script>
export default {
  props: {
    deal: {
      type: Object,
      default: {
        seller: {
          name: "Apple inc.",
          image: {
            url: "/images/sellers/apple_logo.svg",
          },
        },
        pricing: {
          totalQuantity: 145,
          minimumQuantity: 50,
          partialSellAllowed: true,
          currency: "EUR",
          unitPrice: 102050,
          currentBid: 95200,
        },
        product: {
          name: "Iphone 14 Pro",
          shortDescription: "Next generation cellular device from Apple.",
          image: {
            url: "/images/products/product2.jpg",
            alt: "Product Image",
          },
        },
      },
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss">
.deal-intro {
  position: relative;
  width: auto;
  flex: 100%;
  min-width: 285px;
  max-width: 100%;
  color: var(--c-text);
  border: 1px solid var(--c-gray-3);
  border-radius: var(--border-radius-s);
  box-shadow: var(--box-shadow-1);
  transition: 200ms ease;

  &:hover {
    transform: scale(1.03, 1.03);
    box-shadow: var(--box-shadow-3);
    z-index: var(--z-level-2);
    border: 1px solid var(--c-gray-5);
  }
}

.media-block {
  width: 100%;
  height: 150px;
}

.brand-block {
  background: var(--c-gray-1);
  padding: var(--margin-s) var(--margin-m);
  border-top: 1px solid var(--c-gray-2);
  border-bottom: 1px solid var(--c-gray-2);
}

.brand-image-container {
  height: 35px;
  width: 35px;
  font-size: var(--font-s);
}

.brand-label {
  color: var(--c-gray-4);
}

.brand-name {
  font-weight: 600;
}

.product-block {
  padding: var(--margin-l) var(--margin-m) var(--margin-m) var(--margin-m);
}

.product-name {
  font-size: var(--font-xl);
  font-weight: 600;
  text-align: center;
  display: block;
  margin-bottom: var(--margin-xs);
}

.product-description {
  font-size: var(--font-s);
  opacity: 0.85;
  text-align: center;
  display: block;
}

.info-separator {
  display: block;
  height: 3px;
  width: 50%;
  background-color: var(--c-lead);
  margin: var(--margin-m) auto;
}

.details-block {
  padding: 0 var(--margin-m);

  .detail {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: var(--margin-xs);

    &:last-of-type {
      margin-bottom: 0;
    }

    &__label {
      font-weight: 600;
    }

    &__data {
      color: var(--c-gray-5);
    }
  }
}

.cta-block {
  padding: var(--margin-m) var(--margin-m) var(--margin-l) var(--margin-m);

  .deal-action-button {
    padding-inline-end: 1em;
    padding-inline-start: 1em;
  }
}



</style>
